import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAuth } from '../AuthContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';

function EditRule({ show, handleClose, priceRule, onRuleEdited }) {
  const { auth } = useAuth();
  const [loading, setLoading] = useState(false);

  // State for form fields
  const [id, setId] = useState(0);
  const [source, setSource] = useState('');
  const [diameter, setDiameter] = useState(0);
  const [priceAddon, setPriceAddon] = useState(0); // Default value as a number
  const [delticomAddon, setDelticomAddon] = useState(0); // Default value as a number

  useEffect(() => {
    if(show && priceRule){
      setId(priceRule.id);
      setSource(priceRule.source)
      setDiameter(priceRule.diameter)
      setPriceAddon(priceRule.priceAddon)
      setDelticomAddon(priceRule.delticomAddon)
    }
  }, [priceRule]);

  const handleSubmit = async () => {
    if (priceAddon <= 0 || delticomAddon <= 0) {
      toast.error('Fält måste fyllas i och vara giltiga nummer större än 0.', {
        position: 'bottom-right',
      });
      return;
    }
    

    setLoading(true);

    // Simulate sending data to backend
    const formData = {
      id,
      priceAddon,
      delticomAddon,
    };

    console.log('Form Data:', formData);

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pricerules/edit-price-rule`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.token}`
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success(result.message, {
          position: 'bottom-right'
        });
        handleClose();

        const updatedPricerule = { ...priceRule, ...formData };
        onRuleEdited(updatedPricerule);
      } else {
        toast.error(result.message, {
          position: 'bottom-right'
        });
      }
    } catch (error) {
      console.log(error);
      toast.error('Misslyckades att redigera prisregel: ', error, {
        position: 'bottom-right'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} animation={true}>
      <Modal.Header closeButton>
        <Modal.Title>{source} - {diameter} Tum</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <label htmlFor="priceAddon" className="form-label">Påslag</label>
          <input
            type="number"
            className="form-control"
            value={priceAddon}
            onChange={(e) => setPriceAddon(Number(e.target.value))}
          />
        </div>
        <div>
          <label htmlFor="delticomAddon" className="form-label">
            Delticom påslag (Ex moms)
          </label>
          <input
            type="number"
            className="form-control"
            value={delticomAddon}
            onChange={(e) => setDelticomAddon(Number(e.target.value))}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Stäng
        </Button>
        <Button
          variant="primary"
          className="d-flex justify-content-center align-items-center text-white"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <>
              <Loader className="me-2" /> Sparar...
            </>
          ) : (
            'Spara'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditRule;
